import { useState } from 'react'
import { useSelector } from 'react-redux'
import { selectCartDetails } from 'src/redux/cart/selectors'
import { CartDetails } from 'src/redux/cart/types'
import { useCreateOrder, useUpdateCustomer } from 'src/services/api/queries/queries'

const { REACT_APP_PAYMENT_URL } = process.env

export const useCheckout = () => {
  const cartDetails: CartDetails = useSelector(selectCartDetails)
  const [checkoutSuccess, setCheckoutSuccess] = useState<boolean>(false)
  const [checkoutError, setCheckoutError] = useState<string | null>(null)
  const updateCustomerQuery = useUpdateCustomer()
  const useCreateOrderQuery = useCreateOrder()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const checkout = async () => {
    // Reset states
    setIsLoading(true)
    setCheckoutSuccess(false)
    setCheckoutError(null)

    try {
      const data = await updateCustomerQuery.mutateAsync(cartDetails)
      const order: any = await useCreateOrderQuery.mutateAsync(data)

      const order_date = order.date_created?.split('T')[0] || ''
      const instructions = order.customer_note || ''

      let paymentUrl = `${REACT_APP_PAYMENT_URL}/?d=collection&date=${order_date}&time_window=17%3A00-22%3A00&instructions=${instructions}`;
      window.open(paymentUrl, '_blank')

    }
    catch (error) {
      setCheckoutError(error.message)
    }
    finally {
      setIsLoading(false)
    }
  }

  return { checkout, checkoutSuccess, checkoutError, isLoading }
}
